import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-self: stretch;
  margin: 15px 20px 0;
  flex-direction: column;
  align-items: flex-start;
`

export const AvailabilityContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: 20px;
  background-color: #cbe1ea;
  margin-top: 10px;
`

export interface AvailabilityItemProps {
	active: string;
}

export const AvailabilityItem = styled.div<AvailabilityItemProps>`
  color: ${props => (props.active === 'false' ? '#63A5C0' : 'white')};
  margin: 5px;
  display: flex;
  flex: 1;
  flex-direction:row;
  justify-content: center;
  line-height: 27px;
  /* padding: 5px 0px; */
  border-radius: 16px;
  background: ${(props): string => {
	switch (props.active) {
		default:
			return 'transparent'
		case '0':
			return 'linear-gradient(99.57deg, #346C84 12.75%, #1DB6F8 708.02%)'
		case '1':
			return 'linear-gradient(97.05deg, #346C84 -127.07%, #1DB6F8 594.39%)'
		case '2':
			return 'linear-gradient(93.39deg, #346C84 -200.85%, #1DB6F8 487.42%)'
		case '3':
			return 'linear-gradient(91.39deg, #346C84 -320.85%, #1DB6F8 387.42%)'
		case '4':
			return 'linear-gradient(95.39deg, #346C84 -465.85%, #1DB6F8 287.42%)'
		case '5':
			return 'linear-gradient(90.39deg, #346C84 -665.85%, #1DB6F8 187.42%)'
		case '6':
			return 'linear-gradient(85.39deg, #346C84 -865.85%, #1DB6F8 87.42%)'
	}
}};
`
